import { render, staticRenderFns } from "./PrintFooter.vue?vue&type=template&id=c328a60c&scoped=true&"
import script from "./PrintFooter.vue?vue&type=script&lang=js&"
export * from "./PrintFooter.vue?vue&type=script&lang=js&"
import style0 from "./PrintFooter.vue?vue&type=style&index=0&id=c328a60c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c328a60c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
